import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class GmailService {

  constructor(private http: HttpClient) { }

  grantAccess(code: string, emailAddress: string): Observable<any> {
    var model = {
      code: code,
      email_address: emailAddress
    };

    return this.http
      .post(
        `/api/v1/gmail/grant`,
        model
      );
  }

  testAccess(inboxId: string): Observable<any> {
    return this.http
      .get(
        `/api/v1/gmail/test/${inboxId}`
      );
  }

  grantAccessBot(code: string, emailAddress: string): Observable<any> {
    var model = {
      code: code,
      email_address: emailAddress
    };
    return this.http
      .post(
        `/api/v1/gmail/bot/grant`,
        model
      );
  }

}



// WEBPACK FOOTER //
// ./client/app/services/gmail.service.ts